 $(document).ready(function() {
  var goToTop = $('#back-to-top');
  goToTop.hide();
        $(window).scroll(function(){
          if ($(window).scrollTop()>100) goToTop.fadeIn();
          else goToTop.fadeOut();
      });
    goToTop.on("click", function () {
        $('body,html').animate({scrollTop:0},1000);
        return false;
    });
    repositionArrow();
  $(window).resize(function(){
      repositionArrow();
  });
});
function repositionArrow(){
    if($(window).width() > 1920){
         varRight = ($(window).width() -1920) /2 + 15
        $('#back-to-top a').css('right', varRight); 
    } 
}
